module.exports = __webpack_public_path__ + "img/P11.920562a4.png";